/**
 * Removes all the whitespaces from the passed string.
 * @param {string} value - String value to remove all whitespaces from.
 */
export function removeAllWhitespaces(value: string): string {
    return value.replace(/\s+/g, '');
}
